import React from 'react';
import PropTypes from 'prop-types';
import { BoundedDropdown } from './styles';

export const MemberDropdown = (props) => {
  const {
    onChange,
    options,
    value,
    disabled,
  } = props;

  return (
    <div>
      <BoundedDropdown
        onChange={({ target }) => onChange(target)}
        options={options}
        value={value}
        disabled={disabled}
        downward
        upward={false}
      />
    </div>

  );
};

MemberDropdown.defaultProps = {
  disabled: false,
};

MemberDropdown.propTypes = {
  onChange: PropTypes.func.isRequired,
  options: PropTypes.arrayOf({
    key: PropTypes.string.isRequired,
    text: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
  }).isRequired,
  value: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
};

export default MemberDropdown;
